import api from './api';

export interface OnboardingStatus {
    has_professionals: boolean;
    has_services: boolean;
    has_agendas: boolean;
    onboarding_complete: boolean;
}

export const onboardingApi = {
    getStatus: async (): Promise<OnboardingStatus> => {
        const response = await api.get('/company/onboarding-status/');
        return response.data;
    }
};
